import { z } from "zod";

export const env = z
  .object({
    VITE_REACT_APP_SERVER_URL: z.string(),
    VITE_CASH_AGENT_URL: z.string().default("http://localhost:3117"),
    VITE_PUBLIC_POSTHOG_KEY: z.string(),
    VITE_PUBLIC_POSTHOG_HOST: z.string(),
    VITE_MODE: z.enum(["development", "prod"]),
  })
  // @ts-ignore
  .parse(import.meta.env);
